module.exports = __webpack_public_path__ + "media/customizations/sundancenorthlife/back-555a3fb585a8b9b82c1a8d1700bc53b2.jpg";